import { calculLigneCommandeRemise, miseAJourLignesNormales } from '@/services/devisCommandes/calcul/calculLigneCommandeRemise';
import * as devisConf from '@/configuration/devisConf';

function calcul(ligneRemise, lignesCommandeNormales) {
  if (lignesCommandeNormales.length === 0) {
    // spécifique au front pour éviter des erreurs quand la liste est à 0
    ligneRemise.totalHt = 0;
    ligneRemise.totalHt = 0;
    return;
  }

  ligneRemise.totalAvantRemise = lignesCommandeNormales.reduce(
    (acc, ligne) => acc + ligne.totalHt, 0,
  );

  calculLigneCommandeRemise(ligneRemise);

  ligneRemise.totalHt -= ligneRemise.totalAvantRemise;
  ligneRemise.totalHtAvecLigneRemise = null;

  miseAJourLignesNormales(ligneRemise, lignesCommandeNormales);
}

export default function calculLigneCommandeTypeRemise(lignesCommande) {
  const lignesRemise = lignesCommande.filter(l => l.type === devisConf.REMISE);

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < lignesRemise.length; i++) {
    const ligne = lignesRemise[i];

    const ordreEnCours = ligne.ordre;
    const ordrePrecedent = i === 0 ? -1 : lignesRemise[i - 1].ordre;

    const lignesCommandeNormales = lignesCommande.filter(l => l.type === devisConf.NORMAL
      && l.ordre > ordrePrecedent && l.ordre < ordreEnCours);
    calcul(ligne, lignesCommandeNormales);
  }
}
